<template>
  <v-card class="prompt-container" style="border: none">
    <v-card-title v-if="promptTitle">
      <span class="prompt-title">{{ promptTitle }}
      </span>
    </v-card-title>
    <v-card-text class='position-relative message-content'>
      {{ message }}
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    promptTitle: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
}
</script>
<style scoped>
/* 移动端样式 */
@media (max-width: 767px) {
  .prompt-container {
    width: 100%;
    border: none;
    background: #f3f4f6;
  }

  .prompt-title {
    color: #a100ff;
    font-size: 22px;
    font-weight: 700;
  }

  .message-content {

  }
}

/* 桌面端样式 */
@media (min-width: 768px) {
  .prompt-container {
    width: 734px;
    border: none;
    background: #f3f4f6;
    text-align: center;
  }

  .prompt-title {
    color: #a100ff;
    font-size: 22px;
    font-weight: 700;
  }

  .message-content {
    font-size: 16px;
  }
}
</style>
